// Chakra imports
import {
  Flex,
  Grid,
  Image,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
// assets
import peopleImage from "assets/img/people-image.png";
import logoChakra from "assets/svg/logo-white.svg";
import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";
// Custom icons
import {
  CartIcon,
  DocumentIcon,
  GlobeIcon,
  WalletIcon,
  ProductIcon,
  CategoryIcon
} from "components/Icons/Icons.js";
import React, {useState, useEffect} from "react";
import { dashboardTableData, timelineData } from "variables/general";
import ActiveUsers from "./components/ActiveUsers";
import BuiltByDevelopers from "./components/BuiltByDevelopers";
import MiniStatistics from "./components/MiniStatistics";
import OrdersOverview from "./components/OrdersOverview";
import Projects from "./components/Projects";
import SalesOverview from "./components/SalesOverview";
import WorkWithTheRockets from "./components/WorkWithTheRockets";
import Produit from "../Produit/components/Produit";
import productService from "../../../api/products/products";
import categorieService from "../../../api/categories/categories";

export default function Dashboard() {
  const [products, setProducts] = useState([]); // État pour stocker les produits
    const [categories, setCategories] = useState([]); // État pour stocker les produits
    const [loading, setLoading] = useState(true); // État pour gérer le chargement
    const [error, setError] = useState(null);

  const iconBoxInside = useColorModeValue("white", "white");

  useEffect(() => {
    // Fonction pour récupérer les produits
    const fetchProducts = async () => {
      try {
        setLoading(true); // Activer l'état de chargement
        const responseCat = await categorieService.getCategories();
        const response = await productService.getProducts();
        console.log(response)
        setProducts(response); // Stocker les données récupérées
        setCategories(responseCat)
      } catch (err) {
        console.error("Erreur lors de la récupération des produits :", err);
        setError(err.message || "Une erreur s'est produite.");
      } finally {
        setLoading(false); // Désactiver l'état de chargement
      }
    };

    fetchProducts(); // Appeler la fonction de récupération
  }, []);

  return (
    <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 2 }} spacing='24px'>
        <MiniStatistics
          title={"Total des produits"}
          amount={products.length}
          percentage={55}
          icon={<ProductIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        />
        <MiniStatistics
          title={"Total des catégories"}
          amount={categories.length}
          percentage={5}
          icon={<CategoryIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        />
        {/* <MiniStatistics
          title={"New Clients"}
          amount={"+3,020"}
          percentage={-14}
          icon={<DocumentIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        />
        <MiniStatistics
          title={"Total Sales"}
          amount={"$173,000"}
          percentage={8}
          icon={<CartIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        /> */}
      </SimpleGrid>
      {/* <Grid
        templateColumns={{ md: "1fr", lg: "1.8fr 1.2fr" }}
        templateRows={{ md: "1fr auto", lg: "1fr" }}
        my='26px'
        gap='24px'>
        <BuiltByDevelopers
          title={"Built by Developers"}
          name={"Purity UI Dashboard"}
          description={
            "From colors, cards, typography to complex elements, you will find the full documentation."
          }
          image={
            <Image
              src={logoChakra}
              alt='chakra image'
              minWidth={{ md: "300px", lg: "auto" }}
            />
          }
        />
        <WorkWithTheRockets
          backgroundImage={peopleImage}
          title={"Work with the rockets"}
          description={
            "Wealth creation is a revolutionary recent positive-sum game. It is all about who takes the opportunity first."
          }
        />
      </Grid>
      <Grid
        templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr" }}
        templateRows={{ sm: "repeat(2, 1fr)", lg: "1fr" }}
        gap='24px'
        mb={{ lg: "26px" }}>
        <ActiveUsers
          title={"Active Users"}
          percentage={23}
          chart={<BarChart />}
        />
        <SalesOverview
          title={"Sales Overview"}
          percentage={5}
          chart={<LineChart />}
        />
      </Grid> */}
      <Grid
        // templateColumns={{ sm: "1fr", md: "1fr 1fr", lg: "2fr 1fr" }}
        // templateRows={{ sm: "1fr auto", md: "1fr", lg: "1fr" }}
        gap='24px'
        pt={9}>
        <Projects
          title={"Derniers Produits"}
          captions={["Produit", "Catégorie", "Crée le", ""]}
          data={loading ? [] : products} // Afficher les données récupérées ou un tableau vide si en chargement
          categories={categories}
        />
      </Grid>
    </Flex>
  );
}
